module.exports = function getResource(label, vars = []) {
    const resources = {
        widgetError: 'Trouble connecting to Afterpay. Please use a different payment method or try again later.',
        legalNotice: 'By clicking Continue to Afterpay, I am instructing Sephora to send my order and billing information to Afterpay and understand that information will be subject to the Afterpay terms and the Afterpay privacy policy.'
    };

    return resources[label];
};
